import get from 'lodash/get';

import ReactGA from 'react-ga';
import config from '@config';

export const start = () => {
  if (config.ga.ua) {
    ReactGA.initialize(config.ga.ua, config.ga.options);
  }
};

export const set = ReactGA.set;
export const pageview = ReactGA.pageview;

const getKV = (obj) =>
  Object.keys(obj).reduce((all, key) => ({ ...all, [key]: key }), {});

export const gaCategories = {
  General: 'General',
  Social: 'Social',
  Auth: 'Autenticacion',
  Forecast: 'Edicion de Pronóstico',
  UserProfile: 'Edicion Usuario',
  GlobalRanking: 'Ranking General',
  Rankings: 'Torneos',
};

export const GACategory = getKV(gaCategories);

export const gaActions = {
  // HOME ----------------------------------------------

  ShowWelcome: {
    category: GACategory.General,
    name: 'Muestra de Bienvenida',
  },
  HideWelcome: {
    category: GACategory.General,
    name: 'Cerrar Bienvenida',
  },
  ClickMenuRules: {
    category: GACategory.General,
    name: 'Click en Reglas del Menú',
  },

  // AUTH -------------------------------------------

  LogOutClick: {
    category: GACategory.Auth,
    name: 'Click en Salir',
  },
  LogInClick: {
    category: GACategory.Auth,
    name: 'Click en Ingresar',
  },

  // SOCIAL ------------------------------------------

  FacebookShare: {
    category: GACategory.Social,
    name: 'Click Facebook Share',
  },
  TwitterShare: {
    category: GACategory.Social,
    name: 'Click Twitter Share',
  },
  WhatsappShare: {
    category: GACategory.Social,
    name: 'Click Whatsapp Share',
  },
  EmailShare: {
    category: GACategory.Social,
    name: 'Click Email Share',
  },
  TelegramClick: {
    category: GACategory.Social,
    name: 'Click Telegram',
  },

  // FORECAST ------------------------------------------

  EditScore: {
    category: GACategory.Forecast,
    name: 'Edicion de goles',
  },
  EditTeam: {
    category: GACategory.Forecast,
    name: 'Edicion de equipo',
  },
  EditGroupWinner: {
    category: GACategory.Forecast,
    name: 'Edicion de ganador',
  },
  EditScorer: {
    category: GACategory.Forecast,
    name: 'Edicion de goleador',
  },
  SaveForecast: {
    category: GACategory.Forecast,
    name: 'Click en Guardar',
  },
  ViewForecast: {
    category: GACategory.Forecast,
    name: 'Click en Mi Prónostico',
  },
  ViewResults: {
    category: GACategory.Forecast,
    name: 'Click en Resultados',
  },
  JoinZarFromShare: {
    category: GACategory.Forecast,
    name: 'Click en Empezá a Jugar',
  },

  // USER ------------------------------------------

  // EditUser: {
  //   category: GACategory.UserProfile,
  //   name: 'Edicion de Usuario'
  // },
  SaveUser: {
    category: GACategory.UserProfile,
    name: 'Click en Guardar',
  },
  TermsAndConditions: {
    category: GACategory.UserProfile,
    name: 'Click en Terminos y Condiciones',
  },
  HowToPlay: {
    category: GACategory.UserProfile,
    name: 'Como Jugar',
  },

  // GLOBAL RANKING -------------------------------

  ClickHowCalcsWorks: {
    category: GACategory.GlobalRanking,
    name: 'Click en Como Se Juega del Ranking General',
  },
  ClickOnRankingUser: {
    category: GACategory.GlobalRanking,
    name: 'Click en Participante del Ranking General',
  },

  // PRIVATE RANKINGS -------------------------------

  OpenCreateRanking: {
    category: GACategory.Rankings,
    name: 'Click en Crear un Torneo',
  },
  CloseCreateRanking: {
    category: GACategory.Rankings,
    name: 'Cerrar Nuevo Torneo',
  },
  CreateRanking: {
    category: GACategory.Rankings,
    name: 'Nuevo Torneo',
  },
  OpenEditNameRanking: {
    category: GACategory.Rankings,
    name: 'Click en Editar Nombre de Torneo',
  },
  CloseEditNameRanking: {
    category: GACategory.Rankings,
    name: 'Cerrar Editar Nombre de Torneo',
  },
  OpenInviteRanking: {
    category: GACategory.Rankings,
    name: 'Click en Invitar Participantes a Torneo',
  },
  CloseInviteRanking: {
    category: GACategory.Rankings,
    name: 'Cerrar Invitar Participantes a Torneo',
  },
  RemovedRanking: {
    category: GACategory.Rankings,
    name: 'Torneo Eliminado',
  },
  ClickOnParticipant: {
    category: GACategory.Rankings,
    name: 'Click en Participant de Torneo',
  },
};

export const GAAction = getKV(gaActions);

export const event = (action, options = {}) =>
  ReactGA.event({
    category: get(gaCategories, get(gaActions, `${action}.category`), ''),
    action: get(gaActions, `${action}.name`, ''),
    ...options,
  });

export const niEvent = (action, options = {}) =>
  event(action, {
    ...options,
    nonInteraction: true,
  });

export const eventHandler = (action, options) => () => {
  event(action, options);
};
